import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InPersonValStepOne from './InPersonValStepOne';
import InPersonValStepTwo from './InPersonValStepTwo';
import './InPersonPropDetails.scss';
import { httpsCallable } from 'firebase/functions';
import { functionsB } from '../firebaseConfig';
import LoadingPage from '../OnlineValuation/LoadingPage';

function InPersonPropDetails() {
  const [propertyDetails, setPropertyDetails] = useState({
    postcode: '',
    address: '',
    valuationType: '', 
    name: '',
    email: '',
    phone: '',
  });

  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    setPropertyDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
    console.log('propertyDetails:', propertyDetails);
  };

  // Proceed to the next step
  const handleNext = () => {
    sessionStorage.setItem('propertyDetails', JSON.stringify(propertyDetails));
    setStep(2);
  };

  // Handle form submission
  const handleSubmit = async () => {
    setLoading(true); // Set loading state
    try {
      console.log('Submitting property details:', propertyDetails);
  
      // Call the directStoreValuation function to save data and send email
      const directStoreValuation = httpsCallable(functionsB, 'directStoreValuation');
      await directStoreValuation(propertyDetails);
  
      console.log('Valuation data stored and email sent successfully.');
  
      // Push a virtual page view event to GTM
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'page_view', // Custom event for GTM
        page_path: '/thank-you-4', // Match the page path
        page_title: 'Thank You - Property Valuation', // Optional page title
      });
  
      // Redirect after pushing the virtual page view
      navigate('/thank-you-4');
    } catch (error) {
      console.error('Error submitting valuation:', error.message);
    } finally {
      setLoading(false); // Reset loading state
    }
  };
  
  

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="property-details">
      {step === 1 && (
        <InPersonValStepOne
          propertyDetails={propertyDetails}
          handleChange={handleChange}
          handleNext={handleNext}
        />
      )}
      {step === 2 && (
        <InPersonValStepTwo
          propertyDetails={propertyDetails}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
        />
      )}
    </div>
  );
}

export default InPersonPropDetails;
